module.exports = __webpack_public_path__ + "img/camera.f2c085d5.svg";